const { axios, API_URL, generateHeaders, queryParamsToPathParams } = require('./helper');

/************* Facility *************/

/**
 * @description returns care points by Javelina facility id
 * @param {String} id JV Facility ID 
 */
const listProviderAffiliationsByFacilityID = async (id) => {
    const params = {
        FacilityID: id
    }

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/provider/listprovideraffiliations`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/************* Provider *************/

/**
 * @description returns provider info by NPI
 * @param {String} npi npi of the provider
 */
const searchPhysiciansByNationalProviderID = async (npi) => {
    const params = {
        NationalProviderID: npi
    }

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/provider/searchPhysicians`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns detailed provider info by Javelina Physican Id
 * @param {String} id JV Physican ID 
 */
const getPhysicianByPhysicanID = async (id) => {
    const params = {
        PhysicianID: id
    }

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/physicians`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns care points by Javelina physican id
 * @param {String} id JV Physican ID 
 */
const listProviderAffiliationsByPhysicianID = async (id) => {
    const params = {
        PhysicianID: id
    }

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/provider/listprovideraffiliations`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    listProviderAffiliationsByPhysicianID,
    listProviderAffiliationsByFacilityID,
    getPhysicianByPhysicanID,
    searchPhysiciansByNationalProviderID
}